import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { DialogContainer } from 'common/components';

import * as actions from './actions';
import AttachmentForm from './components/AttachmentForm';
import * as selectors from './selectors';

const Container = ({
    closeModal,
    fetchSystemTypes,
    initialValues,
    isOpenModal,
    reset,
    systemTypes,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (isOpenModal) fetchSystemTypes();
    }, [isOpenModal]);

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);

    return (
        <DialogContainer
            onClose={() => closeModal()}
            open={isOpenModal}
            fullWidth={true}
            title={
                initialValues?.id
                    ? t('Edit attachment')
                    : t('Create attachment')
            }
        >
            <AttachmentForm closeModal={closeModal} systemTypes={systemTypes} />
        </DialogContainer>
    );
};

Container.propTypes = {
    closeModal: PropTypes.func,
    fetchSystemTypes: PropTypes.func,
    initialValues: PropTypes.object,
    isOpenModal: PropTypes.bool,
    reset: PropTypes.func,
    systemTypes: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValues,
    isOpenModal: selectors.getIsOpenModal,
    systemTypes: selectors.getSystemTypesData,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch(actions.closeModal()),
    fetchSystemTypes: () => dispatch(actions.fetchSystemTypes()),
    reset: () => dispatch(actions.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
